export function AnnouncementBar() {
  return (
    <div className="bg-[#38251e] px-4 py-2.5 text-center text-xs font-medium tracking-[0.12em] text-white sm:text-sm">
      HANDCRAFTED BODYCARE • THOUGHTFULLY MADE IN SMALL BATCHES
    </div>
  );
}
